import { render, staticRenderFns } from "./task-mail-settings.vue?vue&type=template&id=38972bc6"
import script from "./task-mail-settings.vue?vue&type=script&lang=js"
export * from "./task-mail-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports